import { Component, EventEmitter, Input, Output } from '@angular/core'
import { IHandlerOperation, TypeOperationEnum } from 'src/app/models/HandlerOperation'
import { GenericsEditable, HandlerOperations, Section } from 'src/app/models/Reports'

@Component({
	selector: 'app-management-recommendation',
	templateUrl: './management-recommendation.component.html'
})
export class ManagementRecommendationComponent {
		@Input() public genericsEditable: GenericsEditable = new GenericsEditable()
		@Input() public managementRecommendations: Array<HandlerOperations> = []
		@Input() public allManagementRecommendations: Array<IHandlerOperation> = []
		@Input() public disabled: boolean = true

		@Output() public changeNextEvaluationToNone: EventEmitter<void> = new EventEmitter()

		public showSelectHandleOperations: boolean = false

		public openSelectorHandlerOperations() {
		this.showSelectHandleOperations = true
	}

		public closeSelectorHandlerOperations(
		event: Array<{
			idMongo: string,
			operation: string,
			legalFundamentation?: string,
			sections: Array<Section>,
			typeOperation: TypeOperationEnum
		}>
	) {
		this.showSelectHandleOperations = false

		// Necessário fazer a manipulação dessa forma para manter a mesma referência de memória
		this.managementRecommendations.length = 0
		this.managementRecommendations.push(...event)

		if(this.checkIfHasSuppressionOrRemovalOperations()) {
			this.changeNextEvaluationToNone.emit()
		}
	}

	public checkIfHasSuppressionOrRemovalOperations () {
		return this.managementRecommendations.some(operation => operation.typeOperation === TypeOperationEnum.REMOVAL || operation.typeOperation === TypeOperationEnum.SUPPRESSION)
	}
}
